import { CalendarConfigurationConfig, State } from '@/views/calendar-configuration/calendar-configuration.types';

const mutations = {
  setCalendarConfiguration(state: State, payload: Partial<CalendarConfigurationConfig>) {
    state.calendarConfiguration = { ...state.calendarConfiguration, ...payload };
  },
  setConfigurationLoading(state: State, payload: boolean) {
    state.configurationLoading = payload;
  },
};

export default mutations;
